import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    h2: "h2",
    hr: "hr",
    li: "li",
    ol: "ol",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "サウンドオンライブ株式会社（以下「当社」といいます。）は、当社が運営する音楽制作マッチングサービス「ONLIVE Studio」（以下「本サービス」といいます。）の提供と会員によるご利用に関して、以下の通り利用規約（以下「本規約」といいます。）を定めます。"
    }), "\n", _jsx(_components.p, {
      children: "本規約は、本サービスをご利用されるすべての会員に対して適用されますので、本サービスのご利用前に、必ず本規約をお読みいただき、同意いただく必要がございます。"
    }), "\n", _jsx(_components.h2, {
      children: "第1条（定義）"
    }), "\n", _jsx(_components.p, {
      children: "本規約において使用する以下の用語は、それぞれ以下に定める意味を有するものとします。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「会員」とは、第３条（登録）に基づいて本サービスを利用することができる者として登録がなされた法人もしくは団体または個人を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「クリエイター会員」とは、第６条（クリエイター登録）に基づき、当社所定の審査に合格し、他の会員からのプロジェクト成果物の作成依頼を受託することができる会員として登録された者を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「プロジェクト」とは、会員からの依頼に対しクリエイター会員が応募し、またはクリエイター会員に対して会員が直接行った委託に対してクリエイター会員が受託したことにより発生する、会員とクリエイター会員との間の音源コンテンツ制作にかかる業務委託契約を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「委託会員」とは、プロジェクトの委託者側である会員を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「受託会員」とは、プロジェクトの受託者側であるクリエイター会員を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「プロジェクト当事者」とは、委託会員および受託会員の総称を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「プロジェクト条件」とは、制作する音源コンテンツの内容、仕様、受託会員が対応可能な修正回数の上限、引渡し期限およびプロジェクト報酬の額その他のプロジェクト遂行にかかる条件を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「プロジェクト成果物」とは、プロジェクトの成果物として受託会員が制作し委託会員に納品する音源コンテンツを意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「プロジェクト報酬」とは、プロジェクトの報酬として委託会員が受託会員に支払う金銭を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「音源コンテンツ」とは、楽曲、音声、歌唱、楽器演奏その他の音および楽譜、歌詞その他の書面ならびに音または書面を固定した媒体またはデータその他の無体物を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「アカウント情報」とは、会員が本サービスを利用するための識別子として本サービスに登録したIDおよびパスワードを意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「本サービス」とは、当社が提供するサービス「ONLIVE Studio」（理由の如何を問わずサービスの名称または内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「本サイト」とは、本サービスの提供に関連して当社が運営するウェブサイトを意味します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "「本契約」とは、本規約に基づいて会員と当社との間で締結される、会員による本サービスの利用に関する契約を意味します。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第2条（適用）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約は、本サービスの提供条件および本サービスの利用に関する当社と会員との間の権利義務関係を定めることを目的として、当社と会員との間の本サービスの利用に関わる一切の関係に適用されます。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社が本サイト内に掲載し、または会員に開示する本サービスの利用に関する規定（利用ガイドその他名称の如何を問わず、以下「本サイト規定」といいます。）は、本規約の一部を構成するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サイト規定が本規約の一部を構成する場合において、本規約の内容と本サイト規定の内容が異なるときは、本規約の規定が本サイト規定に優先して適用されるものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第3条（登録）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社所定の一定の情報（以下「登録情報」といいます。）を当社所定の方法で提供することにより、当社に対し、本サービスの利用を登録することができます。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項の規定により会員としての登録が完了した時点をもって、当該登録希望者と当社との間で本契約が有効に成立します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前各項の規定により、会員として登録できる条件は、以下の各号のすべてを満たす場合とします。ただし、法人または団体が登録する場合は、第１号は適用されません。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "１８歳以上の者であること"
          }), "\n", _jsx(_components.li, {
            children: "本規約のすべての条項に同意すること"
          }), "\n", _jsx(_components.li, {
            children: "当社に提供した登録情報の全部が真正であること"
          }), "\n", _jsx(_components.li, {
            children: "第１７条（契約解除）第１項第８号または第９号に該当しないこと"
          }), "\n", _jsx(_components.li, {
            children: "過去に当社との契約に違反した者またはその関係者であると当社が判断する者ではないこと"
          }), "\n", _jsx(_components.li, {
            children: "法人または団体が会員となる場合において、登録手続きを行う者が、当該法人等の規則に基づき当該法人等を代表して対外的に契約を締結する権限を有している者であること"
          }), "\n", _jsx(_components.li, {
            children: "代理人その他会員となる本人以外の者による登録ではないこと"
          }), "\n", _jsx(_components.li, {
            children: "有効な本契約を有する者ではないこと"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第4条（登録情報の変更）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、登録情報に変更があった場合は、当社所定の方法により遅滞なく自己の登録情報を変更するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員が前項の変更を怠ったことに起因して会員に損害が生じた場合は、当社は一切の責任を負いません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第5条（アカウント情報の管理）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、自己の責任において、アカウント情報を適切に利用、保管および管理するものとし、これを第三者に利用させ、または第三者への貸与、譲渡、名義変更、売買その他の提供をしてはなりません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "アカウント情報の管理不十分、使用上の過誤、第三者の使用等によって生じた損害に関するすべての責任は、会員が負うものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第6条（クリエイター登録）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "クリエイター登録を希望する会員は、当社所定の一定の情報を当社所定の方法で提供することにより、当社に対し、クリエイター会員の登録を申請することができます。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、前項の申請を受けたときは、当社所定の基準に従って当該会員からの申請を審査し、当社がクリエイター会員としての登録を認める場合はその旨を当該会員に通知します。クリエイター会員としての登録は、当社が当該通知を行った時点で完了したものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、会員が以下の各号のいずれかに該当すると判断したときは、クリエイター登録を拒否することができるものとし、当社は当該拒否の理由を開示する義務を負いません。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "当社に提供した情報の全部または一部につき、虚偽、誤記または記載漏れその他の不備があった場合"
          }), "\n", _jsx(_components.li, {
            children: "その他当社がクリエイター登録を適当で無いと判断した場合"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "クリエイター会員は、ポートフォリオページ（自己の実績や作品を紹介するために本サービスにおいて公開するページを意味します。）に掲載する作品その他のコンテンツ（以下「実例作品」といいます。）について、第三者の著作権その他の権利利益を侵害してはならず、自己が当該掲載に関する正当な権利を有することを保証するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社および他の会員は、他の会員の実例作品について一切の利用権および所有権を有しません。ただし、当社が、メンテナンスその他の本サービス運営上必要不可欠な作業を目的として複製する場合は、この限りではありません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第7条（本サービス）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、本サービスを通じて、プロジェクトを遂行するための環境およびそれに付随するシステムを提供します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスにおけるプロジェクトは業務委託契約であり、委託会員は、受託会員に対して、プロジェクトの履行にあたって業務内容または業務遂行についての具体的な指揮命令または監督を行うことはできません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスは、委託会員と受託会員との間で直接業務委託契約を締結することを目的とするものであり、当社は当該業務委託契約の当事者とはなりません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第8条（プロジェクトの開始）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクトは、音源コンテンツの制作の委託を希望する会員（以下「委託希望者」といいます。）と、その制作の受託を希望するクリエイター会員との間で、第１３条（知的財産権）第１項および第２項所定の事項ならびにプロジェクト条件について協議のうえ決定し、委託希望者が第１１条（決済）に基づいてプロジェクト報酬の全額を支払ったことが確認できた時点で有効に成立します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項の規定によりプロジェクトが成立した時点をもって、受託会員は、プロジェクト条件に従って、善良なる管理者の注意をもって誠実にプロジェクトを遂行してプロジェクト成果物を制作し委託会員に引渡す義務が発生します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト条件においてプロジェクト成果物の納入期限が定められた場合は、受託会員は、当該納入期限までにプロジェクト成果物を納入するよう努めるものとします。なお、受託会員の故意による場合を除き、当該納入期限までにプロジェクト成果物が納入できなかった場合であっても、本規約への違反を構成するものではなく、受託会員が本規約に基づく罰則を受けるものではありません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "第１項の協議を含め、本規約に定める委託会員と受託会員とのプロジェクト条件の策定に関する連絡および通知を含む音源コンテンツ制作の受発注にかかる一切の協議は、本サービスが提供するメッセージ機能を用いて行うものとし、直接のメールまたは電話等を用いた連絡その他の本サービスが提供する機能を利用しない方法により行ってはなりません。なお、以下の各号のいずれかに該当するものは、本項による制限を受けるものではないため、対面、オンラインミーティングその他の方法を問わず実施できます。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "スタジオ等でのレコーディング作業その他の本サービスの機能では対応できない作業の実施"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクト成立後における、当該プロジェクトの内容や実施状況に関する連絡や協議等"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクト成果物またはプロジェクトの実施に必要なデータの送付"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト成立後、原則としてプロジェクト条件を変更することはできません。ただし、以下の各号のいずれかのときにおいてプロジェクト当事者の協議に基づく合意がある場合は、当該合意に基づいてプロジェクト条件の全部または一部を変更することができるものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "病気、怪我、行政からの要請その他の不可抗力が生じたことによりプロジェクト条件の遵守が困難になったとき"
          }), "\n", _jsx(_components.li, {
            children: "委託会員からの要望に応えるために必要があると受託会員が判断したとき"
          }), "\n", _jsx(_components.li, {
            children: "前各号のほか、プロジェクト条件の変更が必要となる合理的な理由があるとき"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "成立したプロジェクトは、特段の事情により当社が認めた場合を除き、解除することはできません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト当事者は、以下の各号の義務を履行する他、プロジェクト履行にかかる法令を遵守するものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "委託会員が支払うプロジェクト報酬について源泉徴収する義務がある場合は、当該源泉徴収にかかる所得税法その他関連法令に基づく義務"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクトが下請代金支払遅延等防止法の対象となる場合は、当該法に定められた親事業者として委託会員が負う義務"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第9条（プロジェクト成果物の検査）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "委託会員は、受託会員からプロジェクト成果物の提示を受けたときは、遅滞なくプロジェクト条件に適合しているか否かの検査を行い、その結果を受託会員に通知します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "受託会員がプロジェクト成果物を提示してから４８時間経過しても委託会員からの検査結果の通知がない場合は、当該プロジェクト成果物は検査に合格したものとみなします。ただし、不可抗力その他の委託会員の責めに帰さざるべき事由が生じたことにより通知が遅滞した場合は、この限りではありません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "第１項の検査の結果、プロジェクト条件に不適合となった場合は、受託会員は修正その他の対応を行い、再度第１項に従って検査を受けるものとします。ただし、修正その他の対応を行った回数が、プロジェクト条件で定めた修正回数上限を超えるときは、受託会員は、成果物が検査に合格したものとみなすことができるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "委託会員は、前項の規定により修正その他の作業を受託会員に要請するときは、不適合となった理由および修正等の内容について、できるだけ具体的に指示するよう努めるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "第３項ただし書きによらず、プロジェクト成果物に以下の各号その他の社会通念上受託会員の過失によって生じたと考えられる欠陥があるときは、プロジェクト条件で定めた修正回数上限を超える場合であっても、委託会員は、受託会員に対し、当該欠陥の修補を要請することができるものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "意図しない雑音が混在しているとき"
          }), "\n", _jsx(_components.li, {
            children: "音源コンテンツの一部が欠損、欠落しているとき"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクト条件で指定した納品形式またはデータ形式と異なるとき"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第10条（プロジェクトの終了）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前条の規定により、受託会員が提示した成果物が検査に合格したときは、プロジェクト当事者は遅滞なくプロジェクト遂行に関する評価を当社所定の方法で投稿するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項所定の評価の投稿完了をもって、プロジェクトの完了とします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト当事者が投稿した評価は、特段の事情がある場合を除き、本サービスにおいて公開されるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前各項の規定によらず、以下の各号のいずれかに該当するときは、プロジェクトは終了したものとし、当社は、委託会員が支払い済みのプロジェクト報酬を委託会員に全額返金することができるものとします。返金に要する手数料は、委託会員の負担とします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "プロジェクトがプロジェクト当事者の合意により解除され、当社が両当事者からその旨を確認できたとき"
          }), "\n", _jsx(_components.li, {
            children: "受託会員がプロジェクト成果物の引渡しその他のプロジェクトに基づく義務の履行を遅滞し、委託会員または当社がその履行を催促したにも関わらず、当該催告から１週間を経過しても受託会員が当該義務を履行しなかったとき"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクト当事者のいずれかが、相手方に対し、プロジェクト遂行の中断または停止の意思表示を行った場合において、当該意思表示が行われてから１週間を経過しても相手方からの承諾または不承諾の意思表示が行われていないことを当社が確認したとき"
          }), "\n", _jsx(_components.li, {
            children: "プロジェクト当事者間でのトラブルその他の事由が生じたことにより、プロジェクトの完了が困難であると当社が判断したとき"
          }), "\n", _jsx(_components.li, {
            children: "前各号のほか、社会通念上合理的な理由に基づき、支払済みのプロジェクト報酬を委託会員に返還すべきであると当社が判断したとき"
          }), "\n"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第11条（決済）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "委託希望者は、クリエイター会員と合意したプロジェクト報酬の全額を、当社所定の方法で支払うものとします。第８条（プロジェクトの開始）第１項所定の協議に基づくプロジェクト条件の決定がなされてから１週間を経過しても支払いが確認できない場合は、委託希望者が当該合意を取り消したものとみなします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、プロジェクトの完了を確認したときは、遅滞なく委託会員が支払い済みのプロジェクト報酬額から第１２条（手数料）第２項所定の手数料を差し引いた額を受託会員に支払うものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、委託会員によるプロジェクト報酬の支払い（前条第４項に基づく返金処理も含みます。）、および受託会員に対するプロジェクト報酬の支払いに関する事務について、当社に委託するものとし、当社は、会員に対して、当該事務から直接的に発生する義務に対してのみ責任を負うものとします。なお、委託者から受託者に対するプロジェクト報酬の支払いは、当社が当該報酬の全額を受領した時点で完了するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、前項の支払いに関する事務について、ストライプジャパン株式会社（以下「Stripe」といいます。）が提供する決済処理サービスを利用します。会員は、本規約への同意をもって、自己がStripe Connectアカウント契約（https://stripe.com/connect-account/legal/full）およびStripe利用規約（https://stripe.com/legal）（Stripeによって修正された場合は、それぞれ修正後のものを含みます。）に拘束されることについて同意したものとみなされます。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Stripeが提供するサービスを通じて本サービスの決済処理が正常かつ適切に行われるようにするために、会員は、自己に関する正確かつ完全な情報を本サービスに提供することに同意し、かつ本サービスが当該情報およびStripeが提供する決済処理サービスの会員による利用に関連する取引情報を共有することについて承諾するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "如何なる理由においても、プロジェクト当事者間でプロジェクト報酬およびこれに準ずる名目の金銭を直接収受してはなりません。また、直接の収受が行われた場合であっても、委託会員（委託希望者を含みます。）は、第１１条（決済）第１項に基づくプロジェクト報酬の支払い義務を免れません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第12条（手数料）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスへの登録は無料です。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "委託会員は、本サービスの手数料として、成立したプロジェクトのプロジェクト報酬の２０％を当社に支払うものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第13条（知的財産権）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト成果物にかかるすべての著作権（著作権法第２７条および第２８条の権利を含みます。）および著作隣接権は、プロジェクト当事者の協議により、その帰属を決定するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクト当事者は、プロジェクト成果物にかかる著作者人格権および実演家人格権の行使について、協議により決定することができるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスに関する画像、写真、イラスト、デザイン、文章、映像、音楽、音声その他のコンテンツ（ただしプロジェクト成果物および会員が本サービスに投稿、送信等したものを除きます。）にかかる特許権、商標権、意匠権、実用新案権（これらの登録を受ける権利を含みます。）および著作権（以下総称して「知的財産権」といいます。）は、全て当社または当社にライセンスを許諾している者に帰属しています。本規約に別段の規定がある場合を除き、本契約により、会員に対してその利用を許諾するものではございません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、プロジェクトの委託会員および受託会員の双方から承諾を得た場合に限り、本サービス又は当社のプロモーションその他広告宣伝の目的で、当該プロジェクトの概要、実績その他の情報及び当該プロジェクトのプロジェクト成果物が公開されている場合は当該プロジェクト成果物を、無償で複製、公衆送信、翻案その他の利用ができるものとします。なお、本項の規定は、当該プロジェクト成果物の知的財産権の全部または一部が当社に移転することを意味するものではありません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項所定の当社による利用について、当該プロジェクトの受託者は、著作者人格権および実演家人格権を行使しないものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第14条（個人情報保護）"
    }), "\n", _jsx(_components.p, {
      children: "当社は、当社が定めるプライバシーポリシー（https://onlive.studio/privacy）に従って、会員から取得した会員に関する情報を適切に取り扱うものとし、当社による当該取扱い（法令の規定により本人の同意が必要となる事項も含みます。）について、会員は同意するものとします。"
    }), "\n", _jsx(_components.h2, {
      children: "第15条（秘密保持）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、本サービスに関連して当社または他の会員（以下「開示者」といいます。）から開示された開示者の営業上または技術上の情報およびノウハウその他の非公知の情報（以下「秘密情報」といいます。）について、開示者の事前の承諾がある場合を除き、開示を受けた当事者（以下「受領者」といいます。）は、善良な管理者の注意義務をもって厳重に保管管理するものとし、第三者に漏洩、譲渡および貸与し、ならびにプロジェクト履行および本サービスの利用以外の目的で利用してはならないものとします。ただし、以下の各号のいずれかに該当する情報は、秘密情報に該当しないものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "開示者から受領した時、受領者が既に自ら所有していた情報"
          }), "\n", _jsx(_components.li, {
            children: "開示者から受領した時、既に公知であった情報"
          }), "\n", _jsx(_components.li, {
            children: "開示者から受領した後、受領者の責めに帰すべき事由によらずに公知となった情報"
          }), "\n", _jsx(_components.li, {
            children: "正当な権限を有する第三者から守秘義務を伴わずに合法的に入手した情報"
          }), "\n", _jsx(_components.li, {
            children: "受領者が秘密情報に依存することなく独自に創作または開発した情報"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項の規定は、プロジェクト当事者間で別途秘密保持に関する契約の締結を妨げるものではありません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第16条（禁止事項）"
    }), "\n", _jsx(_components.p, {
      children: "会員は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為または該当すると当社が判断する行為をしてはなりません。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "法令または公序良俗に反する行為　"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社または第三者（他の会員を含み、以下本条において同様とします。）の知的財産権、肖像権、名誉または声望その他の権利または利益を侵害する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社に対する詐欺または脅迫行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスを通じ、当社または第三者に対する、誹謗中傷、名誉または信用を毀損する表現、ハラスメントおよび暴力的な表現、わいせつな表現、差別を助長する表現、反社会的な表現その他不快感を与える表現を送信する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "プロジェクトが成立する前におけるクリエイター会員に対する業務または役務提供の委託、および業務または役務の提供を開始する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "第８条（プロジェクトの開始）第４項の規定に違反し、本サービスを介さずに会員間で直接に行う音源コンテンツ制作の受発注およびその協議"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスまたは当社に対する誹謗中傷行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスおよび本サイトへの不正アクセス行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスの他の会員のアカウント情報の利用その他第三者になりすます行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスの運営および提供を妨害し、または妨害するおそれのある行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスのネットワーク、システム等に過度な負荷をかける行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスおよび本サイトに対するリバースエンジニアリングその他の解析行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社に対し、故意に虚偽の事実を開示し、または報告する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社に故意に不利益、損害、不快感を与える行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本サービスの趣旨、目的を超えて異性との出会いを目的とした行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "他の会員による本サービスの利用、またはプロジェクト成立もしくは履行を妨害する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "業務委託契約（請負または準委任およびこれらに準ずるものをいいます。）以外の契約形態で業務を依頼する行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "マルチ、ねずみ講、MLMその他の連鎖取引を目的とする業務、または連鎖取引への勧誘が疑われる業務に関する委託行為"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前各号の行為を試みること"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "その他、当社が不適切と判断する行為"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第17条（契約解除）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、会員が以下の各号のいずれかに該当すると判断した場合は、会員の責めに帰すべき事由の有無に関わらず、当社の裁量により催告なく当該会員による本サービスの利用を一時停止し、または本契約の全部を解除することができるものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "前条各号のいずれかの行為をした場合"
          }), "\n", _jsx(_components.li, {
            children: "本規約のいずれかの条項に違反し、催告を受けてから１４日経過してもなお当該違反が改善されない場合"
          }), "\n", _jsx(_components.li, {
            children: "登録情報に虚偽の事実があることが判明した場合"
          }), "\n", _jsx(_components.li, {
            children: "当社からの問い合わせその他の回答を求める連絡に対して３０日間以上応答がない場合"
          }), "\n", _jsx(_components.li, {
            children: "第３条（登録）第３項各号のいずれかに該当しない場合"
          }), "\n", _jsx(_components.li, {
            children: "他の会員もしくは第三者から受けた苦情、または発生したトラブルが当社所定の水準を超えた場合"
          }), "\n", _jsx(_components.li, {
            children: "当該会員に関して、当社が他の会員または第三者から受けた苦情が当社所定の水準を超えた場合"
          }), "\n", _jsx(_components.li, {
            children: "自己または会員の代表者、役員、支配人その他重要な従業員が反社会的勢力（暴力団、暴力団員または暴力団員でなくなったときから５年を経過しないもの、暴力団準構成員、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団、その他これらに準ずる暴力的な要求行為、法的な責任を超えた不当な要求行為を行う勢力）に該当し、または反社会的勢力が会員の経営を支配し、もしくは実質的に関与していると認められる場合"
          }), "\n", _jsx(_components.li, {
            children: "自己または第三者をして、当社に対し、暴力的な要求行為、法的な責任を超えた不当な要求行為、または取引に関して脅迫的な言動をし、もしくは暴力を用いる行為をした場合"
          }), "\n", _jsx(_components.li, {
            children: "過去に当該会員による本サービスの不適切な利用があった場合"
          }), "\n", _jsx(_components.li, {
            children: "当社または第三者の権利または利益を不当に侵害するおそれがある場合"
          }), "\n", _jsx(_components.li, {
            children: "社会通念上合理的な理由に基づき、本サービスの提供が不適切である場合"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社が前項に基づき本契約の全部を解除した場合において、当該解除の対象となった会員に対して支払う予定であるプロジェクト報酬その他の金銭が存在する場合、当社は、当社の裁量により当該支払いを留保し、または当社が指定する方法での清算その他当社が必要であると認めた処置を行うことができるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約に基づく解除は、当社から会員に対する損害賠償請求を妨げません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本条に基づく本契約の解除は、将来に向かってのみその効力を生じるものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第18条（退会）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、当社所定の手続きの完了により、本サービスの利用を停止し、自己の会員としての登録を抹消することができます。ただし、進行中のプロジェクトが存在する場合は、当該プロジェクトが終了するまで登録を抹消することはできません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "前項の規定による会員としての登録の抹消をもって、当社と会員との間の本契約は解除されるものとし、当該解除について前条第４項を準用します。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員が退会する場合において、当社に対して負っている債務が存在する場合は、会員は、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払いを行わなければなりません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第19条（本サービスの停止）"
    }), "\n", _jsx(_components.p, {
      children: "当社は、以下のいずれかに該当するときは、事前に会員に通知することなく、本サービスの全部または一部の提供を停止することができるものとします。"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "地震、火災、落雷、風水害、感染症の蔓延その他の不可抗力により本サービスの提供が困難となった場合"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "Stripeおよび第三者が提供するものを含む、本サービスにかかるコンピューター、システム、通信回線等に関して、障害が発生し、または保守作業を行う場合"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "その他、当社が本サービスの停止を必要と判断した場合"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第20条（本サービスの変更、終了）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、当社の裁量により、本サービスの内容の全部もしくは一部を変更し、または提供を終了することができるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、本サービスの提供を終了する場合は、終了日の１か月前までに本サイトに掲示するものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第21条（免責）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、会員に対して当社が考え得る最善のサービスを提供いたしますが、本サービスの利用が、会員の特定の目的に適合すること、期待する利益、正確性、有用性、完全性および利用価値を有すること、本サービスの利用が会員に適用のある法令または業界団体の内部規則等に適合すること、ならびに不具合が生じないことについて、何ら保証するものではございません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、クリエイター会員について、会員が期待するプロジェクト成果物が納品されること、およびプロジェクト遂行に関する責任能力、遂行能力その他の能力の有無、ならびにプロジェクト条件に関して一切の関知および保証をせず、また何らの責任も負いません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、以下の各号のいずれについても、一切の責任を負わないものとします。"
        }), "\n", _jsxs(_components.ol, {
          children: ["\n", _jsx(_components.li, {
            children: "会員自身の責任によるもの、およびGoogle、Stripeその他第三者が提供するサービスの停止、障害その他当社の責めに帰することができない事由に起因する本サービスの利用不能、不完全提供ならびに直接かつ現実に生じた場合に限らず当該事由に起因して会員に生じた一切の損害その他不利益"
          }), "\n", _jsx(_components.li, {
            children: "第１９条（本サービスの停止）各号その他当社の責めに帰することができない事由に起因する本契約の履行不能、不完全履行および履行遅滞"
          }), "\n", _jsx(_components.li, {
            children: "本規約に基づく当社による措置に関連して会員が被った損害"
          }), "\n"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "第８条（プロジェクトの開始）第４項各号の実施に関連する場合を含め、本サービスに関連して会員と他の会員または第三者との間に生じた取引、連絡、トラブル、紛争等については、会員が自己の責任において解決するものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約の他の規定に関わらず、会員が被った損害に対して、法令の定めもしくは確定判決により当社が不法行為責任もしくは債務不履行責任を負う場合、または当該損害が当社の故意もしくは重過失に起因する場合は、当社はその責任を負うものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第22条（損害賠償）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、本規約に違反し、または本サービスの利用に関して当社に損害を与えた場合は、当社に対しその全ての損害（弁護士等の専門家の費用も含みます。）を賠償しなければならないものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社が会員に対して賠償責任を負う場合、その範囲は会員に現実に生じた通常の損害に限るものとし、かつ当該賠償責任を負う原因が最初に生じたプロジェクトにかかる手数料相当額（該当するプロジェクトが存在しない場合は、金５，０００円）を上限とします。ただし、当社の故意または重過失に起因する場合は、この限りではありません。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第23条（本規約の改定）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、本サービス内容の変更、法令の改正、社会情勢の変化その他事情により本規約の変更が必要であると合理的に判断した場合は、民法５４８条の４に基づき、本規約を変更することができるものとします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約を変更する場合は、事前に変更後の本規約の施行時期および内容を本サイト上での掲示その他適切な方法により周知し、または会員に通知します。ただし、法令上、会員の同意が必要となる内容の変更の場合は、当社所定の方法で会員の同意を得るものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第24条（通知）"
    }), "\n", _jsx(_components.p, {
      children: "当社から会員に対する通知または連絡、および本規約の変更に関する通知、ならびに会員から当社に対する通知または連絡は、メール送信その他当社所定の方法にて行うものとします。"
    }), "\n", _jsx(_components.h2, {
      children: "第25条（権利義務の譲渡）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "会員は、当社の書面による事前の承諾なく、本契約上の地位または本規約に基づく権利もしくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い本契約上の地位、本規約に基づく権利および義務並びに会員に関する情報を当該事業譲渡の譲受人に譲渡することができるものとし、会員は、かかる譲渡につき本項において予め同意したものとみなします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "第26条（分離可能性）"
    }), "\n", _jsx(_components.p, {
      children: "本規約のいずれかの条項が消費者契約法その他の法令により無効または執行不能と判断された場合であったとしても、当該条項が本契約にとって重要かつ不可欠なものでない限り、他の条項の有効性には何らの影響も及ぼさないものとします。"
    }), "\n", _jsx(_components.h2, {
      children: "第27条（誠実協議）"
    }), "\n", _jsx(_components.p, {
      children: "本規約に定めのない事項、または本規約の解釈について疑義が生じたときは、会員および当社は誠実に協議し、誠意をもってその解決にあたるものとします。"
    }), "\n", _jsx(_components.h2, {
      children: "第28条（存続条項）"
    }), "\n", _jsx(_components.p, {
      children: "退会、契約解除その他理由を問わず本契約が終了した後も、第１３条（知的財産権）、第１４条（個人情報保護）、第１５条（秘密保持）、第１８条（退会）第３項、第２１条（免責）、第２２条（損害賠償）、第２９条（準拠法および裁判管轄）および本条の規定は、有効に存続するものとします。"
    }), "\n", _jsx(_components.h2, {
      children: "第29条（準拠法および裁判管轄）"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約および本契約の準拠法は日本法とします。"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "本規約または本サービスの利用に起因し、または関連する一切の紛争（裁判所の調停手続きを含みます。）については、当社の本店所在地を管轄する地方裁判所を第一審の専属的合意管轄裁判所とします。"
        }), "\n"]
      }), "\n"]
    }), "\n", _jsx(_components.hr, {}), "\n", _jsx(_components.p, {
      children: "2023年6月2日　制定"
    }), "\n", _jsx(_components.p, {
      children: "2025年8月1日　改定"
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
